/* src/app/shared/date-picker/date-picker.component.scss */
.button {
  position: absolute;
  top: 50%;
  margin-top: -12px;
  margin-left: -12px;
  width: 30px;
  height: 30px;
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid var(--ion-color-primary);
  background-color: var(--ion-color-primary);
  border-radius: 5px;
}
.left {
  left: 25px;
}
.right {
  right: 10px;
}
ion-icon {
  font-size: 20px;
}
ion-datetime-button::part(native) {
  position: relative;
  padding: 0;
  top: 0;
  background: transparent;
  color: #ffffff;
  width: 100%;
}
ion-grid {
  padding-top: 12px;
  min-height: 60px;
}
.date-style {
  position: relative;
  top: 2px;
  color: var(--ion-color-light);
  background-color: var(--ion-color-primary);
  border-radius: 5px;
  font-weight: 400;
  font-size: 19px;
  height: 30px;
}
.caret {
  position: relative;
  top: -1px;
}
.left-caret {
  left: -1px;
}
/*# sourceMappingURL=date-picker.component.css.map */
